module.exports = __webpack_public_path__ + "static/media/bookmark.ec9d9ea7.svg";